import { commitMutation } from 'react-relay'
import graphql from 'babel-plugin-relay/macro'

import environment from '../../../../environments/pom/Environment'

const mutation = graphql`
  mutation CreateLetterMutationMutation(
    $companyId: ID!
    $companyLayoutId: Int!
    $letterType: LetterType!
  ) {
    Me {
      Company(id: $companyId) {
        businessPost {
          data: createLetter(
            companyLayoutId: $companyLayoutId
            letterType: $letterType
          ) {
            id
            tableId
          }
        }
      }
    }
  }
`

export default (variables = {}, accessToken, callBack, errorCallBack) => {
  commitMutation(environment(accessToken), {
    mutation,
    variables,
    onCompleted: callBack,
    onError: errorCallBack,
  })
}
